
export default
	props:
		direction:
			type: String
			validator: (val) -> val in ["next", "prev"]
			default: "next"

		disabled:
			type: Boolean

		renderAsDiv:
			type: Boolean

	methods:
		click: -> @$emit 'click'

	computed:
		classes: -> [
			@direction,
		]

		component: ->
			if @renderAsDiv then return 'div'
			else return 'button'

